import { render, staticRenderFns } from "./addWorkshopPersonModal.vue?vue&type=template&id=66d000ac&"
import script from "./addWorkshopPersonModal.vue?vue&type=script&lang=js&"
export * from "./addWorkshopPersonModal.vue?vue&type=script&lang=js&"
import style0 from "./addWorkshopPersonModal.vue?vue&type=style&index=0&id=66d000ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports